"use client"

import type React from "react"
import { Typography } from "antd"
import logo from "../../../shared/assets/images/CQLogo.svg"
import { ReactComponent as Warning } from "../../../shared/assets/images/blueWarningIcon.svg"
import { InvitationNotValidProps } from "./types"

const { Title, Paragraph } = Typography



const InvitationNotValid: React.FC<InvitationNotValidProps> = ({
    title,
    message,
    supportEmail,
    showRetry = false,
    onRetry,
}) => {

    const resolvedTitle = title || "Invitation link expired"
    const resolvedMessage = message || 'This interview link is no longer valid. It may have expired, been used, withdrawn, or replaced—please contact your recruiter for a new one'

    return (
        <div
            className="flex items-center justify-center min-h-screen p-4 sm:p-6 lg:p-8"
            style={{ background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)" }}
        >
            <div
                className="w-full max-w-2xl"
                style={{
                    animation: "slideUp 0.5s ease-out",
                }}
            >
                <div className="overflow-hidden bg-white shadow-lg rounded-2xl">
                    <div className="flex flex-col gap-4 px-6 py-5 border-b border-gray-100 sm:px-8 sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex items-center gap-3">
                            <img src={logo} alt="people logo" width={40} height={40} className="rounded-full" />
                            <span className="text-xl font-semibold text-gray-900">people</span>
                        </div>
                        <span className="inline-flex items-center px-3 py-1.5 text-xs font-medium tracking-wide text-gray-600 uppercase bg-gray-50 rounded-full border border-gray-200">
                            AI interview access
                        </span>
                    </div>

                    <div className="px-6 py-8 sm:px-8 sm:py-10">
                        <div className="flex flex-col items-center gap-4 text-center">
                            <div>
                                <Warning className="w-12 h-12" />
                            </div>

                            <div className="max-w-lg space-y-3">
                                <Title level={2} className="!mb-0 !text-lg sm:!text-lg !font-semibold !text-gray-900">
                                    {resolvedTitle}
                                </Title>
                                <Paragraph className="!mb-0 !text-sm !text-gray-600 !leading-relaxed">
                                    {resolvedMessage}
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
        </div>
    )
}

export default InvitationNotValid
